import HomePage from './pages/HomePage';

export const homeRoute = {
  name: 'home',
  path: '/',
  exact: true,
  component: HomePage
};

export const homeAliasRoute = {
  name: 'home',
  path: '/confluence-sandbox-editor',
  exact: true,
  component: HomePage
};
